export default __webpack_public_path__ + "static/media/mslogo.a359bb39.png";